import ErrorPage, { ErrorType } from 'common/components/errorPages/ErrorPage';

export default function ErrorFallback({ error }: any) {
  /// @TODO log error to server with userdata
  console.error(error);

  return <ErrorPage errorType={ErrorType.ERROR} />;
}
